import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-environment-banner',
  standalone: true,
  imports: [CommonModule], // Necessário para *ngIf
  template: `
    @if (showBanner) {
      <div class="environment-banner">
        MODO DE TESTE - HOMOLOGAÇÃO
      </div>
    }
  `,
  styles: [`
    .environment-banner {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      background-color: #ff0000;
      color: white;
      text-align: center;
      padding: 8px;
      font-weight: bold;
      z-index: 9999;
      box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    }
  `]
})
export class EnvironmentBannerComponent {
  protected readonly showBanner = environment.envName === 'homolog';
}
